'use strict';

var React = require('react');

var SvgMicrophoneMajor = function SvgMicrophoneMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a3.25 3.25 0 0 0-3.25 3.25v2a3.25 3.25 0 0 0 6.5 0v-2a3.25 3.25 0 0 0-3.25-3.25Zm1.75 5.25a1.75 1.75 0 1 1-3.5 0v-2a1.75 1.75 0 1 1 3.5 0v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8a.75.75 0 0 0-1.5 0v.25c0 3.06 2.29 5.585 5.25 5.954v1.546h-1.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-1.25v-1.546a6.001 6.001 0 0 0 5.25-5.954v-.25a.75.75 0 0 0-1.5 0v.25a4.5 4.5 0 1 1-9 0v-.25Z"
  }));
};
SvgMicrophoneMajor.displayName = "MicrophoneMajor";

exports.SvgMicrophoneMajor = SvgMicrophoneMajor;
